<style lang="less" scoped>
.root-edit-modal {
    padding: 0
}
</style>
<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="showModal"
        scrollable
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ editedItem.id?'编辑':'新增' }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-list-item
                    two-line
                    class="root-edit-modal"
                  >
                    <v-list-item-content>
                      <v-list-item-title>申请人</v-list-item-title>
                      <v-list-item-subtitle>{{ cur_customer.account }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-autocomplete
                    v-model="editedItem.apply_team_id"
                    :disabled="!!editedItem.id"
                    :items="product_teams.filter(item=>!item.del)"
                    item-text="name"
                    item-value="id"
                    label="预算需求团队"
                  />
                </v-col>   
                <v-form
                  ref="form"
                  :value="true"
                  style="width: 100%;"
                >
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="审批名称*"
                      required
                      :rules="rules.name"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-menu
                      v-model="showDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="dateToquarter(editedItem.quarter_start_at)"
                          label=""
                          placeholder="季度起始时间*"
                          readonly
                          v-bind="attrs"
                          :rules="rules.date_check"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="editedItem.quarter_start_at"
                        type="month"
                        no-title
                        scrollable
                        reactive
                        locale="zh-cn"
                        :allowed-dates="allowedMonths"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="showDateMenu = false"
                        >
                          关闭 
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.apply_reason"
                      rows="4"
                      label="申请事由*"
                      required
                      auto-grow
                      :rules="rules.apply_reason"
                    />
                  </v-col>
                </v-form>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              :disabled="loading"
              @click="cancel"
            >
              取消
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="loading"
              @click="ok"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { budgetOrderCreateApi, budgetOrderUpdateApi } from '../service'
  const initData = () => ({
    id:undefined,
    name: '',
    apply_reason: '',
    quarter_start_at: '',
    apply_team_id: ''
  })
  const quarter_start = ['01', '04', '07', '10']
  export default {
    data() {
      return {
        showModal: false,
        loading: false,
        editedItem: initData(),
        showDateMenu:false,
        canEdit: false,
      }
    },
    computed: {
      ...mapGetters('async', {
        product_teams: 'product_teams',
      }),
      cur_customer() {
        return this.$store.state.cur_customer
      },
      rules() {
        return {
          name:[data => {
            if (!data || (data && !data.trim())) {
              return '审批名称必填'
            }
            return true
          }],
          apply_reason: [data => {
            if (!data || (data && !data.trim())) {
              return '申请事由必填'
            }
            return true
          }],
          date_check: [
            data => !!data || '请选择申请时间'
          ],
        }
      }
    },
    methods: {
      dateToquarter(date = '') { // 绑定季度展示
        if (!date) {
          return ''
        }
        const date_n = Number(date.slice(-2))
        return `${date}【第${Math.ceil(date_n / 3)}季度】`
      },
      allowedMonths(date) { // 季度开始月份可选
        const select_month = date.slice(-2)
        const is_start = quarter_start.includes(select_month) // 季度开始的月份
        let month = moment().quarter() * 3 - 2 // 当前季度的起始月份
        month = month >= 10 ? month : `0${month}` 
        const current_season = `${moment().format('YYYY')}-${month}` 
        if (is_start && date >= current_season) {
          return true
        }
        return false
      },
      // user_flow current_user_flow_node flow_node key_name
      show(data) {
        this.canEdit = true
        if (data) {
          Object.keys(this.editedItem).forEach(key => {
            this.editedItem[key] = data[key]
          })
          this.editedItem.quarter_start_at = (this.editedItem.quarter_start_at || '').slice(0, 7)
          this.canEdit = ['user_flow', 'current_user_flow_node', 'flow_node', 'key_name'].reduce((total, key) => total[key] || '', data || {}) !== 'BUDGET_COMMIT'
        } else {
          this.editedItem = initData()
          this.editedItem.apply_team_id = this.$store.state.cur_customer.team_id
        }
        this.showModal = true
      },
      cancel() {
        this.showModal = false
        this.showDateMenu = false
        this.$refs.form.resetValidation()
      },
      ok() {
        if (this.$refs.form.validate()) {
          const go = this.editedItem.id ? budgetOrderUpdateApi : budgetOrderCreateApi
          const params = {}
          this.loading = true
          Object.keys(this.editedItem).forEach(key => {
            params[key] = this.editedItem[key]
          })
          params.quarter_start_at = params.quarter_start_at + '-01'
          go(params).then((res) => {
            this.$Message.success({
              content: this.editedItem.id ? '编辑成功' : '新增成功',
              duration:0.9
            })
            this.cancel()
            this.$emit('success', this.editedItem.id === undefined, res)
          }).finally(() => {
            this.loading = false
          })
        }
      }
    }
  }
</script>
